import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
  BusinessCodeService,
  CustomerService,
  ProductsService,
  DistributorsService,
  MediasService,
} from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FormBuilder, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd';
import { UploaderComponent } from '../../../shared/uploader';
import {
  capitalizeFirstLetter,
  removeAllSpacingBetweenWords,
} from '../../../helpers';
declare var $: any;

@Component({
  selector: 'app-media-update',
  templateUrl: './media-update.component.html',
  styleUrls: ['./media-update.component.scss'],
})
export class MediaUpdateComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();
  id: string;
  loadGLN = true;
  loadGroups = true;
  loadProduct = false;
  form = this.fb.group({
    name: ['', [Validators.required]],
    send_types: ['', [Validators.required]],
    enterprise: null,
    customerGroupIds: [[]],
    numberOfMessage: ['', [Validators.required]],
    title: ['', [Validators.required]],
    message: ['', [Validators.required]],
    productAttachmentId: '',
    notifTargetType: ['', [Validators.required]],
    notifTargetValue: ['', [Validators.required]],
    date: ['', [Validators.required]],
    time: ['', [Validators.required]],
  });
  // ===data ==== //
  name;
  images = [];
  title = '';
  content = '';
  notifTargetType;
  firstNotiType;
  valueNotifTarget = '';
  product;
  date;
  time;
  phone = '';
  totalNoti = 0;
  totalInapp = 0;
  messTotal = '';
  // ====end data==== //
  showProduct = false;
  showNotifTarget = false;
  checkOptions = [
    { label: 'Thông báo Notification', value: '2' },
    { label: 'Tin nhắn lnapp', value: '1' },
  ];
  isLoading = false;
  searchChange$ = new BehaviorSubject('');
  // tslint:disable-next-line:variable-name
  list_gln = [];
  groups = [];

  productName = '';
  products = [];
  distributors = [];

  validName = false;
  validNotifTargetType = false;
  validnumberOfMessage = false;
  validTitle = false;
  validContent = false;
  validNotifTargetValue = false;
  messName = '';
  messTitle = '';
  messContent = '';
  messPhone = '';
  disabled = false;
  disabledTest = false;
  radioValue = 'A';
  sendAction = 'bookSend';
  contentMessage: any;
  messTemplate = '';
  validTemplate = false;

  constructor(
    private activedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NzModalService,
    private codeService: BusinessCodeService,
    private notification: NzNotificationService,
    private customerService: CustomerService,
    private productsService: ProductsService,
    private distributorsService: DistributorsService,
    private mediasService: MediasService
  ) {
    // @ts-ignore
    const optionList$: Observable<string> = this.searchChange$.asObservable();
    // .pipe(debounceTime(500));
    optionList$.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      this.list_gln = [];
      this.groups = [];
      this.products = [];
      this.distributors = [];

      if (this.loadGLN) {
        const queryGLN = {
          name: value.trim(),
          status: 1,
          page: 1,
          page_size: 50,
        };
        this.codeService
          .list(queryGLN)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              res.data.items.map((item) => {
                const data = {
                  value: item.id,
                  label: item.name + '(' + item.glnCode + ')',
                };
                this.list_gln.push(data);
              });
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
              this.list_gln = [];
            }
          );
      }

      if (this.loadGroups) {
        const queryGroup = {
          keyword: value.trim(),
          page: 1,
          page_size: 50,
        };
        this.customerService
          .listGroup(queryGroup)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              this.isLoading = false;
              this.groups = [];
              if (res.code === 1) {
                const ids = [];
                const list = res.data.items;
                list.map((item) => {
                  ids.push(item.id);
                });
                this.groups = list;
              }
            },
            (error) => {
              this.isLoading = false;
              this.groups = [];
            }
          );
      }

      if (this.loadProduct) {
        const queryProduct = {
          product_name: value.trim(),
          management_status: 1,
          page: 1,
          page_size: 50,
        };
        this.productsService
          .getAll(queryProduct)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              const data = res.data.items;
              if (data != null) {
                data.map((item) => {
                  const product = {
                    id: undefined,
                    name: undefined,
                  };
                  if (item.productName) {
                    product.id = item.productId;
                    product.name =
                      item.productName + ' ' + '(' + item.barcode + ')';
                  } else {
                    product.id = item.productId;
                    product.name = '(' + item.barcode + ')';
                  }
                  this.products.push(product);
                });
              }
              this.isLoading = false;
            },
            (error) => {
              this.isLoading = false;
              this.products = [];
            }
          );
      }

      // tslint:disable-next-line:triple-equals
      if (this.notifTargetType == 3) {
        const queryDistributors = {
          name: value.trim(),
          page: 1,
          page_size: 50,
        };
        this.distributorsService
          .list(queryDistributors)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res) => {
              this.isLoading = false;
              res.data.items.map((item) => {
                const data = {
                  value: item.id,
                  label: item.name,
                };
                this.distributors.push(data);
              });
            },
            (error) => {
              this.isLoading = false;
              this.distributors = [];
            }
          );
      }
    });
  }

  ngOnInit() {


    this.notification.config({
      nzPlacement: 'bottomRight',
    });
    this.id = this.activedRoute.snapshot.paramMap.get('id');
    this.mediasService
      .getCampaignById(this.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            const data = res.data;
            console.log('data', data);
            const brandName = data.brandName;
            const campaignType = data.campaignType;
            const customerGroupId = data.customerGroups.map(z => z.id);
            const enterpriseId = data.enterprise.id;
            if (data.status !== 0 && data.status !== 2) {
              this.disabled = true;
            }
            // handle send_types
            this.radioValue = data.send_types[0] === 3 ? 'B' : 'A';

            if (this.radioValue === 'B') {
              this.form.get('title').clearValidators();
              this.form.get('message').clearValidators();
              this.form
                .get('customerGroupIds')
                .setValidators([Validators.required]);
              this.form.updateValueAndValidity();
            }

            this.form.controls.name.setValue(data.name);
            let options: any = [];
            data.send_types.map((item) => {
              if (item === 1) {
                this.loadProduct = true;
              }
              if (item === 2) {
                const type = data.notifTarget.type;
                if (type === 2) {
                  this.searchGLN('');
                }
                if (type === 3) {
                  this.searchDistributors('');
                }
                if (type === 4) {
                  this.searchProduct('');
                }
              }
            });

            this.checkOptions.map((option) => {
              // tslint:disable-next-line:radix
              if (data.send_types.includes(parseInt(option.value))) {
                const op = {
                  label: option.label,
                  value: option.value,
                  checked: true,
                };
                options.push(op);
              } else {
                const op = {
                  label: option.label,
                  value: option.value,
                  checked: false,
                  disabled: false,
                };
                // tslint:disable-next-line:radix
                if (parseInt(option.value) === 3) {
                  op.disabled = true;
                }
                options.push(op);
              }
            });
            this.checkOptions = options;
            this.form.controls.send_types.setValue(options);

            if (data.send_types[0] === 3) {
              options = [
                {
                  label: 'SMS Brandname',
                  value: data.send_types[0],
                  checked: true,
                },
              ];
              this.form.controls.send_types.setValue(options);
            }
            if (data.enterprise !== undefined) {
              this.form.controls.enterprise.setValue(data.enterprise.id);
            }
            this.loadGLN = true;
            this.loadGroups = true;
            // this.searchChange$.next("");
            const groupIds = [];
            data.customerGroups.map((group) => {
              groupIds.push(group.id);
            });
            this.form.controls.customerGroupIds.setValue(groupIds);
            this.form.controls.numberOfMessage.setValue(data.numberOfMessage);
            if (data.images[0]) {
              const image = {
                type: 'jpeg',
                name: 'image',
                url: data.images[0],
              };
              this.images.push(image);
            }
            this.form.controls.title.setValue(data.title);
            let mess$ = data.message;
            if (mess$.includes('[CUSTOMER_NAME]')) {
              mess$ = data.message
                .split('[CUSTOMER_NAME]')
                .join('#Tên khách hàng#');
            }
            if (mess$.includes('[CUSTOMER_PHONE')) {
              mess$ = mess$
                .split('[CUSTOMER_PHONE]')
                .join('#Điện thoại khách hàng#');
            }

            this.form.controls.message.setValue(mess$);

            if (data.productAttachment) {
              this.form.controls.productAttachmentId.setValue(
                data.productAttachment.id
              );
            } else {
              this.form.controls.productAttachmentId.setValue(undefined);
            }
            if (data.notifTarget) {
              this.showNotifTarget = true;
              this.form.controls.notifTargetType.setValue(
                `${data.notifTarget.type}`
              );
              this.notifTargetType = data.notifTarget.type;
              if (this.notifTargetType === 1) {
                this.form.controls.notifTargetValue.setValue(
                  `${data.notifTarget.valueObj.value}`
                );
                this.valueNotifTarget = data.notifTarget.valueObj.value;
              } else {
                this.form.controls.notifTargetValue.setValue(
                  `${data.notifTarget.valueObj.id}`
                );
                this.valueNotifTarget = data.notifTarget.valueObj.id;
              }
            } else {
              this.form.controls.notifTargetType.setValue(undefined);
              this.showNotifTarget = false;
              this.notifTargetType = undefined;
              this.valueNotifTarget = undefined;
            }
            this.firstNotiType = this.notifTargetType;
            const sendAt = data.sendAt.split('/');
            // tslint:disable-next-line:variable-name
            const sendAt_converted = [sendAt[1], sendAt[0], sendAt[2]].join(
              '-'
            );
            this.form.controls.date.setValue(sendAt_converted);
            this.form.controls.time.setValue(
              new Date(Date.parse(sendAt_converted))
            );

            if (data.templateType && this.radioValue === 'B') {
              this.contentMessage = {
                templateType: data.templateType,
                templateContent: data.message,
                brandName: data.brandName,
              };
              if (data.templateType == 1) {
                this.contentMessage.templateText = 'CSKH';
              }
              if (data.templateType == 2) {
                this.contentMessage.templateText = 'Thông tin nội bộ';
              }
              if (data.templateType == 3) {
                this.contentMessage.templateText = 'Quảng cáo';
              }
            }
          } else {
            this.notification.error(
              'Lấy thông tin chiến dịch thất bại',
              res.message
            );
          }
        },
        (error) => {
          this.notification.error(
            'Lấy thông tin chiến dịch thất bại',
            'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
          );
        }
      );
    this.mediasService
      .getTotalNoti()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.code === 1) {
          if (res.code === 1) {
            this.totalNoti =
              res.data.notificationQuota !== null
                ? res.data.notificationQuota
                : 0;
            this.totalInapp =
              res.data.messageQuota !== null ? res.data.messageQuota : 0;
          }
        }
      });
  }
  cancel(){

  }

  searchGLN(event) {
    this.loadGLN = true;
    this.loadGroups = false;
    this.loadProduct = false;
    this.list_gln = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchGroup(event) {

    this.loadGLN = false;
    this.loadGroups = true;
    this.loadProduct = false;
    this.groups = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchProduct(event) {
    this.products = [];
    this.loadGLN = false;
    this.loadGroups = false;
    this.loadProduct = true;
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  searchDistributors(event) {
    this.loadGLN = false;
    this.loadGroups = false;
    this.distributors = [];
    this.isLoading = true;
    this.searchChange$.next(event);
  }

  async log(value: object[]) {
    this.form.controls.numberOfMessage.setValidators([Validators.required]);
    this.showProduct = false;
    const checked = [];
    await value.map((item) => {
      // @ts-ignore
      if (item.checked === true) {
        // @ts-ignore
        checked.push(item.value);
      }
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      if (item.value == 1 && item.checked == true) {
        this.showProduct = true;
        this.searchProduct('');
      }
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      if (item.value == 2 && item.checked == true) {
        this.showNotifTarget = true;
      }
    });
    if (checked.includes('1') && !checked.includes('2')) {
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(this.totalInapp),
      ]);
      this.messTotal =
        'Số tin nhắn Inapp gửi đi không được lớn hơn số lượng còn lại';
    }
    if (checked.includes('2') && !checked.includes('1')) {
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(this.totalNoti),
      ]);
      this.messTotal =
        'Số tin nhắn Notification gửi đi không được lớn hơn số lượng còn lại';
    }
    if (checked.includes('1') && checked.includes('2')) {
      // tslint:disable-next-line:max-line-length
      this.form.controls.numberOfMessage.setValidators([
        Validators.required,
        Validators.max(
          this.totalNoti < this.totalInapp ? this.totalNoti : this.totalInapp
        ),
      ]);
      this.messTotal = 'Số tin nhắn gửi đi không được lớn hơn số lượng còn lại';
    }
    this.form.controls.numberOfMessage.updateValueAndValidity();
    if (checked.length > 0) {
      this.validNotifTargetType = false;
    }
    let list$;
    checked.map((item) => {
      // tslint:disable-next-line:triple-equals
      if (item == 2) {
        list$ = item;
      }
    });
    if (!list$) {
      this.showNotifTarget = false;
      this.notifTargetType = undefined;
    }
  }

  notiChange(event) {
    // tslint:disable-next-line:triple-equals
    if (event == this.firstNotiType) {
      this.form.controls.notifTargetValue.setValue(this.valueNotifTarget);
    } else {
      this.form.controls.notifTargetValue.setValue(undefined);
    }
    this.notifTargetType = event;
    // tslint:disable-next-line:triple-equals
    if (event == 4) {
      this.searchProduct('');
    }
    // tslint:disable-next-line:triple-equals
    if (event == 3) {
      this.searchDistributors('');
    }
    // tslint:disable-next-line:triple-equals
    if (event == 2) {
      this.searchGLN('');
    }
  }

  inputChange(event) {
    this[event] = false;
    if ($('.message') && $('.message')[0]) {
      $('.message').scrollTop($('.message')[0].scrollHeight);
    }
  }
  setTag(event) {
    const message = this.form.controls.message.value;
    const value = '#' + event + '# ';
    const valueForm = message.trim().length > 0 ? message + ' ' + value : value;
    this.form.controls.message.setValue(valueForm);
  }

  update(value: string) {
    const dataForm$ = this.form.value;
    const checked = [];
    if (dataForm$.send_types) {
      dataForm$.send_types.map((item) => {
        // @ts-ignore
        if (item.checked === true) {
          checked.push(parseInt(item.value, 10));
        }
      });
    }

    let type$;
    let typeInapp$;

    console.log(checked);

    checked.map((item) => {
      if (item === 1) {
        typeInapp$ = item;
      }
      if (item === 2) {
        type$ = item;
      }
    });
    this.form.controls.notifTargetType.setValidators([Validators.required]);
    this.form.controls.notifTargetValue.setValidators([Validators.required]);
    if (type$ === undefined) {
      this.form.controls.notifTargetType.clearValidators();
      this.form.controls.notifTargetValue.clearValidators();
    }
    // tslint:disable-next-line:forin
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) {
      return;
    }
    this.validName = false;
    if (dataForm$.name.trim().length === 0) {
      this.messName = 'Tên chiến dịch không hợp lệ';
      this.validName = true;
    }
    if (dataForm$.name.trim().length > 255) {
      this.messName = 'Tên chiến dịch không quá 255 ký tự';
      this.validName = true;
    }
    this.validNotifTargetType = false;
    // tslint:disable-next-line:triple-equals
    if (checked.length == 0) {
      this.validNotifTargetType = true;
    }
    this.validnumberOfMessage = false;
    if (dataForm$.numberOfMessage % 1) {
      this.validnumberOfMessage = true;
    }
    this.validTitle = false;
    if (this.radioValue === 'A' && dataForm$.title.trim().length === 0) {
      this.validTitle = true;
      this.messTitle = 'Tiêu đề không hợp lệ';
    }
    if (this.radioValue === 'A' && dataForm$.title.trim().length > 255) {
      this.validTitle = true;
      this.messTitle = 'Tiêu đề không quá 255 ký tự';
    }
    this.validContent = false;
    if (dataForm$.message.trim().length === 0) {
      this.validContent = true;
      this.messContent = 'Nội dung không hợp lệ';
    }
    if (dataForm$.message.trim().length > 255) {
      this.validContent = true;
      this.messContent = 'Nội dung không quá 255 ký tự';
    }
    let date = dataForm$.date ? this.getDate(dataForm$.date, 1) : '';
    let time = dataForm$.time ? this.getDate(dataForm$.time, 2) : '';
    if (this.sendAction === 'sendNow') {
      date = this.getDate(new Date(), 1);
      time = this.getDate(new Date(), 2);
    }
    const sendAt$ = date + ' ' + time;
    let mess$ = dataForm$.message;
    if (mess$.includes('#Tên khách hàng')) {
      mess$ = mess$.replace(/#Tên khách hàng#/g, '[CUSTOMER_NAME]');
    }
    if (mess$.includes('#Điện thoại khách hàng')) {
      mess$ = mess$.replace(/#Điện thoại khách hàng#/g, '[CUSTOMER_PHONE]');
    }

    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) {
      return;
    }
    // tslint:disable-next-line:max-line-length
    if (this.radioValue === 'A') {
      if (
        this.validName ||
        this.validnumberOfMessage ||
        this.validTitle ||
        this.validContent ||
        this.validNotifTargetType
      ) {
        return;
      }
    }

    if (this.radioValue === 'B') {
      if (this.validName || this.validnumberOfMessage) {
        return;
      }
    }


    const body = {
      name: capitalizeFirstLetter(removeAllSpacingBetweenWords(dataForm$.name)),
      send_types: checked,
      customerGroupIds: dataForm$.customerGroupIds,
      numberOfMessage: dataForm$.numberOfMessage,
      images: this.images.length > 0 ? [this.images[0].url] : [''],
      title: dataForm$.title,
      message: mess$,
      productAttachmentId: undefined,
      sendAt: sendAt$,
      enterpriseId: dataForm$.enterprise,
      notifTarget: undefined,
      phone: undefined,
      campaignType: this.radioValue === 'A' ? 0 : 1,
      templateType:
        this.contentMessage && this.contentMessage.templateType
          ? this.contentMessage.templateType
          : null,
      brandName:
        this.contentMessage && this.contentMessage.brandName
          ? this.contentMessage.brandName
          : '',
    };
    // tslint:disable-next-line:triple-equals
    if (typeInapp$ != undefined && dataForm$.productAttachmentId) {
      body.productAttachmentId = dataForm$.productAttachmentId;
    }
    // tslint:disable-next-line:triple-equals
    if (type$ != undefined) {
      body.notifTarget = {
        // tslint:disable-next-line:radix
        type: dataForm$.notifTargetType,
        value: dataForm$.notifTargetValue,
      };
    }
    if (value === 'test') {
      this.disabledTest = true;
      body.phone = this.phone.trim();
      this.mediasService
        .testCampaign(body)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (res) => {
            this.disabledTest = false;
            if (res.code === 1) {
              this.notification.success(
                'Thành công',
                'Gửi test chiến dịch thành công'
              );
            } else {
              this.notification.error(
                'Gửi test chiến dịch thất bại',
                res.message
              );
            }
          },
          (error) => {
            this.disabledTest = false;
            this.notification.error(
              'Gửi test chiến dịch thất bại',
              'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
            );
          }
        );
      return;
    }
    this.disabled = true;

    console.log(body);
    this.mediasService
      .update(this.id, body)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.disabled = false;
          if (res.code === 1) {
            this.notification.success(
              'Thành công',
              'Cập nhật chiến dịch thành công'
            );


            setTimeout(() => {
              this.router.navigate(['/business/media']);
            }, 1000);
          } else {


            this.notification.error(
              'Cập nhật chiến dịch thất bại',
              res.message
            );
          }
        },
        (error) => {
          this.disabled = false;

          this.notification.error(
            'Cập nhật chiến dịch thất bại',
            'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
          );
        }
      );
  }

  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          this[field] = [];
          this[field].push(data);
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe((changeParam) => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number) {
    this[field].splice(index, 1);
  }

  // tslint:disable-next-line:variable-name
  getDate(date, number) {
    const today = new Date(date);
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    const hh = today.getHours();
    const minute = today.getMinutes();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    if (number === 1) {
      return dd + '/' + mm + '/' + yyyy;
    }
    return hh + ':' + minute;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  resetDateTime() {
    // this.date = null;
    // this.time = null;
  }

  loadDataChild($event: any) {
    this.contentMessage = $event;
    this.validTemplate = false;
    this.messTemplate = '';
    console.log($event);
  }
}
